import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "flex flex-wrap gap-1 w-full flex-col input" };
const _hoisted_2 = {
    key: 0,
    class: "w-fit relative"
};
const _hoisted_3 = {
    key: 0,
    class: "text-red-600 mr-1"
};
const _hoisted_4 = {
    key: 2,
    class: "flex gap-2"
};
const _hoisted_5 = ["for"];
const _hoisted_6 = {
    key: 0,
    class: "text-red-600 mr-1"
};
const _hoisted_7 = { class: "text-[10px] text-[--color-50]" };
import Editor from "primevue/editor";
import FileUpload from "primevue/fileupload";
import UDecimalInput from "./UDecimalInput.vue";
import UTooltip from "./UTooltip.vue";
import { Checkbox, DatePicker, InputMask, InputNumber, InputText, Select, Textarea } from "primevue";
import USlider from "@/components/uikit/uComponents/USlider.vue";
import { computed, inject, onMounted, ref } from "vue";
import { convertVideoLink } from "@/help/convertVideoLinks";
export default /*@__PURE__*/ _defineComponent({
    __name: 'UInput',
    props: {
        modelValue: {},
        name: { default: "" },
        type: { default: "text" },
        placeholder: {},
        disabled: { type: Boolean },
        invalid: { type: Boolean },
        error: {},
        label: {},
        note: {},
        tooltip: {},
        required: { type: Boolean },
        options: {},
        minDate: {},
        maxDate: {},
        min: {},
        max: {},
        decimals: {},
        indent: {},
        dateSelectionMode: { default: "single" },
        customRule: {},
        step: {},
        intermediateHandler: {}
    },
    emits: ["update:modelValue"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const stringValue = ref(props.modelValue?.toString() || "");
        const booleanValue = ref(props.modelValue === "true");
        const dateValue = ref(props.modelValue ? new Date(props.modelValue.toString()) : null);
        const numberValue = ref(typeof props.modelValue === "number" ? props.modelValue : null);
        const sliderValue = ref(typeof props.modelValue === "string" ? 0 : Number(props.modelValue));
        const updateEditorValue = (value) => {
            stringValue.value = value.htmlValue;
            emit("update:modelValue", value.htmlValue);
        };
        const updateDateValue = (value) => {
            dateValue.value = value;
            emit("update:modelValue", value?.toString());
        };
        const updateBooleanValue = (value) => {
            console.log(value);
            booleanValue.value = value;
            emit("update:modelValue", value);
        };
        const updateStringValue = (value) => {
            if (props.intermediateHandler) {
                value = props.intermediateHandler(value);
            }
            stringValue.value = value;
            emit("update:modelValue", value);
        };
        const updateStringVideo = (value) => {
            const link = convertVideoLink(value);
            stringValue.value = value;
            emit("update:modelValue", link);
        };
        const updateNumberValue = ($event) => {
            const newVal = $event && "value" in $event ? $event.value : null;
            let value = newVal ?? null;
            if (props.intermediateHandler) {
                value = props.intermediateHandler(value);
            }
            numberValue.value = value == null ? null : Number(value);
            emit("update:modelValue", value);
        };
        const updateSliderValue = (value) => {
            const val = value ?? null;
            sliderValue.value = val;
            emit("update:modelValue", val);
        };
        const updateSelectValue = (value) => {
            stringValue.value = value;
            emit("update:modelValue", value);
        };
        const updateFileValue = (value) => {
            emit("update:modelValue", value.files);
        };
        const registerInput = inject("registerInput");
        onMounted(() => {
            if (registerInput) {
                registerInput({
                    name: props.name,
                    type: props.type,
                    required: props.required,
                    label: props.label,
                    customRule: props.customRule
                });
            }
        });
        const getFieldError = inject("getFieldError");
        const effectiveError = computed(() => getFieldError?.(props.name) || props.error);
        const error = computed(() => effectiveError.value || props.error);
        return (_ctx, _cache) => {
            const _component_UText = _resolveComponent("UText");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (__props.label && __props.type !== 'boolean')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _createTextVNode(_toDisplayString(__props.label) + " ", 1),
                        (__props.required)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_3, " * "))
                            : _createCommentVNode("", true),
                        (__props.tooltip)
                            ? (_openBlock(), _createBlock(UTooltip, {
                                key: 1,
                                tooltip: __props.tooltip
                            }, null, 8, ["tooltip"]))
                            : _createCommentVNode("", true)
                    ]))
                    : _createCommentVNode("", true),
                (__props.type == 'phone')
                    ? (_openBlock(), _createBlock(_unref(InputMask), {
                        key: 1,
                        mask: "+9 (999) 999-9999",
                        "model-value": stringValue.value,
                        name: __props.name,
                        placeholder: __props.placeholder,
                        disabled: __props.disabled,
                        invalid: __props.invalid || !!error.value,
                        "onUpdate:modelValue": updateStringValue
                    }, null, 8, ["model-value", "name", "placeholder", "disabled", "invalid"]))
                    : (__props.type == 'boolean')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                            _createVNode(_unref(Checkbox), {
                                "input-id": `checkbox-input-${__props.name}`,
                                value: booleanValue.value,
                                "onUpdate:value": updateBooleanValue
                            }, null, 8, ["input-id", "value"]),
                            (__props.label && __props.type == 'boolean')
                                ? (_openBlock(), _createElementBlock("label", {
                                    key: 0,
                                    for: `checkbox-input-${__props.name}`,
                                    class: "w-fit relative cursor-pointer"
                                }, [
                                    _createTextVNode(_toDisplayString(__props.label) + " ", 1),
                                    (__props.required)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_6, " * "))
                                        : _createCommentVNode("", true),
                                    (__props.tooltip)
                                        ? (_openBlock(), _createBlock(UTooltip, {
                                            key: 1,
                                            tooltip: __props.tooltip
                                        }, null, 8, ["tooltip"]))
                                        : _createCommentVNode("", true)
                                ], 8, _hoisted_5))
                                : _createCommentVNode("", true)
                        ]))
                        : (__props.type == 'decimals')
                            ? (_openBlock(), _createBlock(UDecimalInput, {
                                key: 3,
                                "model-value": stringValue.value,
                                name: __props.name,
                                placeholder: __props.placeholder,
                                disabled: __props.disabled,
                                invalid: __props.invalid || !!error.value,
                                max: props.max,
                                min: props.min,
                                decimals: props.decimals,
                                indent: props.indent,
                                "onUpdate:modelValue": updateStringValue
                            }, null, 8, ["model-value", "name", "placeholder", "disabled", "invalid", "max", "min", "decimals", "indent"]))
                            : (__props.type == 'file')
                                ? (_openBlock(), _createBlock(_unref(FileUpload), {
                                    key: 4,
                                    ref: "fileupload",
                                    "show-upload-button": false,
                                    "show-cancel-button": false,
                                    multiple: false,
                                    name: __props.name,
                                    placeholder: __props.placeholder,
                                    disabled: __props.disabled,
                                    invalid: __props.invalid || !!error.value,
                                    accept: "image/*",
                                    "max-file-size": 1000000,
                                    onSelect: updateFileValue
                                }, {
                                    empty: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                                            _createElementVNode("span", null, "Drag and drop files to here to upload.", -1)
                                        ]))]),
                                    _: 1
                                }, 8, ["name", "placeholder", "disabled", "invalid"]))
                                : (__props.type == 'date')
                                    ? (_openBlock(), _createBlock(_unref(DatePicker), {
                                        key: 5,
                                        "model-value": dateValue.value,
                                        name: __props.name,
                                        placeholder: __props.placeholder,
                                        disabled: __props.disabled,
                                        invalid: __props.invalid || !!error.value,
                                        "min-date": __props.minDate,
                                        "max-date": __props.maxDate,
                                        "icon-display": "input",
                                        "selection-mode": __props.dateSelectionMode,
                                        "onUpdate:modelValue": updateDateValue
                                    }, null, 8, ["model-value", "name", "placeholder", "disabled", "invalid", "min-date", "max-date", "selection-mode"]))
                                    : (__props.type == 'number')
                                        ? (_openBlock(), _createBlock(_unref(InputNumber), {
                                            key: 6,
                                            "model-value": numberValue.value,
                                            name: __props.name,
                                            placeholder: __props.placeholder,
                                            disabled: __props.disabled,
                                            invalid: __props.invalid || !!error.value,
                                            onInput: updateNumberValue
                                        }, null, 8, ["model-value", "name", "placeholder", "disabled", "invalid"]))
                                        : (__props.type == 'slider')
                                            ? (_openBlock(), _createBlock(USlider, {
                                                key: 7,
                                                "model-value": sliderValue.value,
                                                name: __props.name,
                                                disabled: __props.disabled,
                                                invalid: __props.invalid || !!error.value,
                                                step: __props.step,
                                                max: __props.max,
                                                "onUpdate:modelValue": updateSliderValue
                                            }, null, 8, ["model-value", "name", "disabled", "invalid", "step", "max"]))
                                            : (__props.type === 'select')
                                                ? (_openBlock(), _createBlock(_unref(Select), {
                                                    key: 8,
                                                    "model-value": __props.modelValue,
                                                    name: __props.name,
                                                    placeholder: __props.placeholder,
                                                    disabled: __props.disabled,
                                                    invalid: __props.invalid || !!error.value,
                                                    options: __props.options,
                                                    "option-label": "display",
                                                    "option-value": "value",
                                                    "onUpdate:modelValue": updateSelectValue
                                                }, null, 8, ["model-value", "name", "placeholder", "disabled", "invalid", "options"]))
                                                : (__props.type === 'editor')
                                                    ? (_openBlock(), _createBlock(_unref(Editor), {
                                                        key: 9,
                                                        "model-value": stringValue.value,
                                                        name: __props.name,
                                                        placeholder: __props.placeholder,
                                                        disabled: __props.disabled,
                                                        invalid: __props.invalid || !!error.value,
                                                        "editor-style": "height: 220px",
                                                        onTextChange: updateEditorValue
                                                    }, {
                                                        toolbar: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                                                                _createElementVNode("span", { class: "ql-formats" }, [
                                                                    _createElementVNode("button", {
                                                                        class: "ql-header",
                                                                        value: "1"
                                                                    }),
                                                                    _createElementVNode("button", {
                                                                        class: "ql-header",
                                                                        value: "2"
                                                                    }),
                                                                    _createElementVNode("button", {
                                                                        class: "ql-header",
                                                                        value: "3"
                                                                    })
                                                                ], -1),
                                                                _createElementVNode("span", { class: "ql-formats" }, [
                                                                    _createElementVNode("button", { class: "ql-bold" }),
                                                                    _createElementVNode("button", { class: "ql-italic" }),
                                                                    _createElementVNode("button", { class: "ql-underline" })
                                                                ], -1),
                                                                _createElementVNode("span", { class: "ql-formats" }, [
                                                                    _createElementVNode("select", { class: "ql-color" })
                                                                ], -1),
                                                                _createElementVNode("span", { class: "ql-formats" }, [
                                                                    _createElementVNode("button", {
                                                                        class: "ql-list",
                                                                        value: "ordered"
                                                                    }),
                                                                    _createElementVNode("select", { class: "ql-align" }, [
                                                                        _createElementVNode("option", { selected: "" }),
                                                                        _createElementVNode("option", { value: "center" }),
                                                                        _createElementVNode("option", { value: "right" }),
                                                                        _createElementVNode("option", { value: "justify" })
                                                                    ])
                                                                ], -1)
                                                            ]))]),
                                                        _: 1
                                                    }, 8, ["model-value", "name", "placeholder", "disabled", "invalid"]))
                                                    : (__props.type == 'textarea')
                                                        ? (_openBlock(), _createBlock(_unref(Textarea), {
                                                            key: 10,
                                                            "model-value": stringValue.value,
                                                            name: __props.name,
                                                            rows: "3",
                                                            cols: "30",
                                                            placeholder: __props.placeholder,
                                                            disabled: __props.disabled,
                                                            invalid: __props.invalid || !!error.value,
                                                            "auto-resize": "",
                                                            "onUpdate:modelValue": updateStringValue
                                                        }, null, 8, ["model-value", "name", "placeholder", "disabled", "invalid"]))
                                                        : (__props.type == 'video')
                                                            ? (_openBlock(), _createBlock(_unref(InputText), {
                                                                key: 11,
                                                                "model-value": stringValue.value,
                                                                name: __props.name,
                                                                placeholder: __props.placeholder,
                                                                disabled: __props.disabled,
                                                                invalid: __props.invalid || !!error.value,
                                                                "onUpdate:modelValue": updateStringVideo
                                                            }, null, 8, ["model-value", "name", "placeholder", "disabled", "invalid"]))
                                                            : (_openBlock(), _createBlock(_unref(InputText), {
                                                                key: 12,
                                                                "model-value": stringValue.value,
                                                                name: __props.name,
                                                                placeholder: __props.placeholder,
                                                                disabled: __props.disabled,
                                                                invalid: __props.invalid || !!error.value,
                                                                "onUpdate:modelValue": updateStringValue
                                                            }, null, 8, ["model-value", "name", "placeholder", "disabled", "invalid"])),
                (__props.note)
                    ? (_openBlock(), _createBlock(_component_UText, {
                        key: 13,
                        class: "-mt-[6px]",
                        size: "small",
                        variant: "simple",
                        severity: "secondary"
                    }, {
                        default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_7, _toDisplayString(__props.note), 1)
                        ]),
                        _: 1
                    }))
                    : _createCommentVNode("", true),
                (error.value)
                    ? (_openBlock(), _createBlock(_component_UText, {
                        key: 14,
                        class: _normalizeClass({ '-mt-2': __props.note }),
                        severity: "error",
                        size: "small",
                        variant: "simple"
                    }, {
                        default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(error.value || effectiveError.value), 1)
                        ]),
                        _: 1
                    }, 8, ["class"]))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
